import DefaultProps from '../../commonTypes/defaultprops.types';

export enum IconSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  AUTO = 'auto'
}

export interface IconProps extends DefaultProps {
  name: string;
  size?: IconSizes;
  width?: number;
  orientation?: number;
  description?: string;
  fill?: string;
  role?: string;
  allowStyleOverride?: boolean;
  allowColorOverride?: boolean;
}

export interface IconSVGProps {
  transform?: string;
  viewBox?: string;
  xmlns?: string;
}
